import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";

// import currencies from 'world-currencies';

export default function Currency({ setCurrnencyTobeConverted }) {
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState("USD");
    const [allcurrency, setallcurrency] = useState([
        { countryName: "United States", countryCode: "US", currencyCode: "USD", currencySymbol: "$" },
        { countryName: "Germany", countryCode: "DE", currencyCode: "EUR", currencySymbol: "€" },
        { countryName: "India", countryCode: "IN", currencyCode: "INR", currencySymbol: "₹" },
        { countryName: "United Kingdom", countryCode: "GB", currencyCode: "GBP", currencySymbol: "£" },
        { countryName: "Australia", countryCode: "AU", currencyCode: "AUD", currencySymbol: "$" },
        { countryName: "Canada", countryCode: "CA", currencyCode: "CAD", currencySymbol: "$" },
        { countryName: "Russia", countryCode: "RU", currencyCode: "RUB", currencySymbol: "₽" },
        { countryName: "South Korea", countryCode: "KR", currencyCode: "KRW", currencySymbol: "₩" },
        { countryName: "Brazil", countryCode: "BR", currencyCode: "BRL", currencySymbol: "$" },
        { countryName: "Japan", countryCode: "JP", currencyCode: "JPY", currencySymbol: "¥" },
        { countryName: "Indonesia", countryCode: "ID", currencyCode: "IDR", currencySymbol: "Rp" }// IDR
        ]
      )
      const filteredCurrencies = allcurrency?.filter((curr) => {
        const searchLower = searchQuery.toLowerCase();
        return (
            curr.currencySymbol.toLowerCase().includes(searchLower) ||
            curr.countryCode.toLowerCase().includes(searchLower) ||   curr.countryName.toLowerCase().includes(searchLower) || curr.currencyCode.toLowerCase().includes(searchLower)
        );
    });
    useEffect(() => {
        const array = allcurrency.sort((a, b) => a.currencyCode.localeCompare(b.currencyCode));
        setallcurrency(array);
    }, []);

    const handleChange =(curr) => {
        setCurrnencyTobeConverted(curr.currencyCode, curr.currencySymbol)
        setSelectedCurrency(curr.currencyCode);
    };

    useEffect(() => {
        console.log("Selected currency:", selectedCurrency);
        
    },[selectedCurrency])

    const handlesearch=(e)=>{
        setSearchQuery(e.target.value)
    }

    return (
        <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                <strong className="d-flex align-items-center gap-2">Select Currency <i class="fa-solid fa-angle-down"></i></strong>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {/* <input
                    className="currSearch"
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    name="search"
                    onChange={handlesearch}
                  
                /> */}
                {filteredCurrencies?.map((curr, idx) => {
                    return (
                        <Dropdown.Item className={curr.currencyCode === selectedCurrency ? 'active' : ''}
                        onClick={()=> handleChange(curr) }
                         key={idx} href="#">
                            {curr.currencySymbol} {curr.currencyCode}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    )
}